import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {AuthProvider} from "oidc-react";
import {notification} from "antd";
import {useHandleAuthentication} from "./handler/authHandler";

const {
    REACT_APP_AUTHORITY,
    REACT_APP_CLIENTSECRET,
    REACT_APP_CLIENTID,
} = process.env;

const oidcConfig = {
    authority: REACT_APP_AUTHORITY,
    redirectUri: `${window.location.origin}/signin-oidc`,
    clientId: REACT_APP_CLIENTID,
    clientSecret: REACT_APP_CLIENTSECRET,
    scope: "openid email profile",
    autoSignIn: false,
    loadUserInfo: false,
    responseType: "code"
};

notification.config({
    placement: "topRight",
    duration: 3,
});

const RootComponent = () => {
    const {handleAuthentication} = useHandleAuthentication();

    return (
            <AuthProvider
                {...oidcConfig}
                onSignIn={(user) => {
                    handleAuthentication(user)
                }}
            >
                <App/>
            </AuthProvider>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <RootComponent/>
);
